var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-heading"},[_c('div',[_c('p',{staticClass:"eyebrow"},[_vm._v(_vm._s(_vm.eyebrow))]),_c('h2',[_vm._v(_vm._s(_vm.title))])]),(_vm.link)?_c('router-link',{staticClass:"text-link",attrs:{"to":_vm.link}},[_vm._v(_vm._s(_vm.linkText)+" "),_c('span',[_vm._v("↗")])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }